import React from "react";
import { LegalPage } from "@/pages/Terms";

const sections = [
  ["1. Information we collect", "We collect your name, email, phone (if provided) and location when you use NearbyDeals to find nearby shops and claim offers."],
  ["2. How we use your data", "Your data is used to show relevant local shops, issue coupons, enable messaging with shops and improve the service."],
  ["3. Location data", "We use your approximate location only to surface shops near you. You can browse a chosen area without sharing precise location."],
  ["4. Sharing", "We share the minimum necessary information with shops when you message them or redeem a coupon. We never sell your personal data."],
  ["5. Cookies & storage", "We store an authentication token in your browser to keep you signed in. No third-party advertising trackers are used for core features."],
  ["6. Your rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting hello@nearbydeals.in."],
  ["7. Security", "Passwords are hashed and never stored in plain text. We take reasonable measures to protect your information."],
];

export default function Privacy() {
  return <LegalPage title="Privacy Policy" sections={sections} />;
}
